/**
 * Same as trackUe.coffee, but using the new typescript
 * common/debug/analytics module.
 */
const getWebContext = require('./get-web-context.coffee');
import Analytics from 'common/debug/analytics';

const analytics = new Analytics();
analytics.setAppContextGetter(getWebContext);

export default analytics;



// WEBPACK FOOTER //
// ./app/scripts/debug/classic-analytics.ts